import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/vector.svg'


const _withScopeId = n => (_pushScopeId("data-v-30409340"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-item" }
const _hoisted_2 = { class: "list-item__left" }
const _hoisted_3 = {
  key: 0,
  class: "date-tag"
}
const _hoisted_4 = {
  key: 0,
  class: "date"
}
const _hoisted_5 = {
  key: 1,
  class: "tag"
}
const _hoisted_6 = { class: "list-item--top" }
const _hoisted_7 = { class: "list-item--top--left" }
const _hoisted_8 = {
  key: 0,
  class: "list-item--top--left__title-target"
}
const _hoisted_9 = { class: "list-item--top--left__title" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "list-item__right" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "vector-img",
    class: "list-item--top--right"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.date || _ctx.tag)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_ctx.date)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.date), 1))
              : _createCommentVNode("", true),
            (_ctx.tag)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.tag), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", null, [
            (_ctx.titleTarget)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.titleTarget), 1))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.title), 1)
          ])
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.describes, (describe, index) => {
        return (_openBlock(), _createElementBlock("p", {
          key: index,
          class: "list-item--bottom"
        }, _toDisplayString(describe), 1))
      }), 128))
    ]),
    _hoisted_10
  ]))
}